import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class PopOverLimit extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-xs-1"></div>
                    <div className="col-xs-7">
                        <label className="label-primary">{this.props.Descripcion}</label>
                    </div>
                    <div className="col-xs-4">
                        <label className="label-primary">${this.props.LimiteCompra}</label>
                    </div>
                </div>
            </div>
        );
    }
};

export default PopOverLimit